import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ServiceAction } from '../../actions';
import ProductErrorInfo from '../../components/product/ProductErrorInfo';
import ProductSimpleInfo from '../../components/product/ProductSimpleInfo';
import SiteInfo from '../../components/site/SiteInfo';
import ServiceCreateForm from './ServiceCreateForm';
import { Translate as t } from '../../config/Translate';

// 오류·제품·사이트 맥락 표시(관리자 2단 / 일반 탭). 입력 양식은 ServiceCreateForm 이 그린다.
const ServiceCreateByErrorCode = ({ referErrorCode, referProduct, referSite, callbackCreated, AddUpdate, withBack = false }) => {
	const isAdmin = location.pathname.toLowerCase().startsWith('/admin/');

	useEffect(() => {
		AddUpdate({});
	}, [])

	const prefill = {
		sn: referProduct?.sn,
		model: referProduct?.model,
		siteId: referSite?.siteId,
		productErrorCodeId: referErrorCode?._id,
		errorCode: referErrorCode?.code,
		effectiveDate: referErrorCode?.begin
	};

	const form = (
		<ServiceCreateForm
			prefill={prefill}
			product={referProduct}
			callbackCreated={callbackCreated}
			withBack={withBack} />
	);

	const [tab, setTab] = useState("error");
	const tabList = [
		{ code: "error", title: t('common.label.error') },
		{ code: "product", title: t('product.title') },
		{ code: "site", title: t('site.title') },
	]

	return (
		<>
			{isAdmin &&
				<div className="row">
					<div className="col pe-0">
						{referErrorCode?._id && <ProductErrorInfo errorCodeInfo={referErrorCode} />}
						{referProduct?._id && <ProductSimpleInfo product={referProduct} />}
						{referSite?.siteId && <SiteInfo siteId={referSite.siteId} />}
					</div>
					<div className="col mb-2 ps-0">
						{form}
					</div>
				</div>
			}
			{!isAdmin &&
				<>
					<div className="section mb-2">
						<ul className="nav nav-tabs style2 mt-1 mb-1">
							{tabList.map(x =>
								<li className="nav-item">
									<button key={x.code}
										className={tab == x.code ? "nav-link active" : "nav-link"} onClick={() => { setTab(x.code); }}>
										{x.title}
									</button>
								</li>
							)}
						</ul>
					</div>
					{form}
					{referErrorCode?._id && tab == "error" &&
						<ProductErrorInfo errorCodeInfo={referErrorCode} />
					}
					{referProduct?._id && tab == "product" &&
						<ProductSimpleInfo product={referProduct} />
					}
					{referSite?.siteId && tab == "site" &&
						<SiteInfo siteId={referSite.siteId} showTitle={true} />
					}
				</>
			}
		</>
	);
};

const mapDispatch = dispatch => ({
	AddUpdate: (info) => dispatch(ServiceAction.AddUpdate(info)),
})

export default connect(null, mapDispatch)(ServiceCreateByErrorCode);
